<script>
    import Fa from 'svelte-fa';
    import { faCircleNotch } from '@fortawesome/pro-regular-svg-icons';

    import { formatMoney } from '$lib/utils/functions/money.js';

    import Button from '$lib/components/Button.svelte';
    import QtyButton from '$lib/components/QtyButton.svelte';
    import ProductOptionSelector from '$lib/components/ProductOptionSelector.svelte';
    import ProductOutOfStock from '$lib/components/ProductOutOfStock.svelte';
    import ProductUpsell from '$lib/components/ProductUpsell.svelte';
    import Modal from '$lib/components/Modal.svelte';

    export let product;
    export let selectedVariant;
    export let upsells;

    let itemQty = 1;
    let cartAdding = false;
    let selectedUpsells = [];

    const productPrice = product?.priceRange?.maxVariantPrice?.amount;
    const compareAtPrice = product?.compareAtPriceRange?.maxVariantPrice?.amount;

    $: discountPercentage = Math.round(((compareAtPrice - productPrice) / compareAtPrice) * 100);
    $: maxQty = selectedVariant?.quantityAvailable || 0;
    $: variantAvailable = selectedVariant?.availableForSale;

    // Prepare selectedUpsells array for cart
    $: selectedUpsellsForCart = selectedUpsells
        .filter((item) => item?.selected && item?.availableForSale)
        .map((item) => ({ merchandiseId: item?.merchandiseId, quantity: item?.quantity }));

    // Sum Total price of all selected upsells
    $: selectedUpsellsSumPrice = selectedUpsells
        .filter((item) => item?.selected && item?.availableForSale)
        .reduce((accumulator, currentItem) => {
            return accumulator + currentItem?.price;
        }, 0);

    // Check if at least one upsells is available for sale
    const isUpsellAvailable = upsells?.some((item) => item?.availableForSale);

    // Show OOS modal if variant or product unavailable
    $: outOfStockModal = variantAvailable === false ? true : false;

    // Add To Cart function
    async function addProductToCart() {
        let selectedVariantForCart = { merchandiseId: selectedVariant.id, quantity: itemQty };
        cartAdding = true;
        cartAdding = await window.cart.addToCart([selectedVariantForCart, ...selectedUpsellsForCart], { openDrawer: true }); // function returns false
        itemQty = 1;
    }
</script>

<ProductOptionSelector options={product.options} variants={product.variants} bind:selectedVariant />

{#if upsells?.length && isUpsellAvailable}
    <div class="mt-4">
        <span class="mb-2 block text-sm font-semibold">Optional Add-Ons</span>
        {#each upsells as upsell, index (upsell)}
            <ProductUpsell {upsell} {index} bind:selectedUpsells />
        {/each}
    </div>
{/if}

<div class={`grid grid-cols-12 items-center gap-1 ${product?.options[0].name === 'Title' ? 'border-0' : 'mt-4 border-t border-base-800 pt-6'}`}>
    <div class="col-span-6 flex items-center gap-2 lg:col-span-3 lg:flex-col lg:items-start lg:gap-0">
        <span class="text-lg font-medium">
            {product?.priceRange?.maxVariantPrice?.currencyCode}
            {formatMoney(+productPrice + +selectedUpsellsSumPrice)}
        </span>

        {#if compareAtPrice && compareAtPrice > productPrice}
            <span class="text-color-text/75 line-through lg:-mt-1">
                {formatMoney(compareAtPrice)}
            </span>
            <div class="absolute right-2 top-3">
                <span class="rounded-full bg-red-700 px-3 py-1.5 text-xs font-semibold text-white">
                    {discountPercentage}% OFF
                </span>
            </div>
        {/if}
    </div>

    <div class="relative col-span-6 flex justify-end lg:col-span-4 lg:justify-normal">
        <QtyButton {maxQty} trash={false} bind:itemQty disabled={false} />
    </div>

    <div class="col-span-12 pt-4 lg:col-span-5 lg:pt-0">
        <Button style="Featured" onclick={addProductToCart} disabled={!variantAvailable} vibrate={10}>
            {#if cartAdding}
                <Fa icon={faCircleNotch} spin={true} size="1.3x" class="m-auto block" />
            {:else if variantAvailable && !cartAdding}
                Add To cart
            {:else}
                Out of Stock
            {/if}
        </Button>
    </div>
</div>

{#if !variantAvailable}
    <Modal name="OutOfStock" bind:modalOpen={outOfStockModal}><ProductOutOfStock {selectedVariant} /></Modal>
{/if}
